import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import SearchBar from '@/components/SearchBar';

interface HeroProps {}

const Hero = ({}: HeroProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="relative mb-6">
      <div className="container mx-auto px-4 md:py-20 relative z-20 my-[10px] pt-12 md:pb-6 pb-0">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-7xl font-normal mb-1 md:mb-8 tracking-tight animate-fade-in text-gray-900 font-prociono"
          style={{
            background: "linear-gradient(90deg, #231617 0%, #89565A 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}
          >
            The Standard for  <br /> Design Talent Worldwide
          </h1>
          
          <p className="text-sm md:text-base text-black mb-0 md:mb-8 animate-fade-in" style={{
            animationDelay: '0.2s'
          }}>
            We make great designers easy to find and trust
          </p>
          
          {/* Search bar for mobile */}
          {isMobile && (
            <div className="mt-8 px-4">
              <SearchBar />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;